import { Controller } from "@hotwired/stimulus";
import { useTransition } from "stimulus-use";

// Base controller adding enter/leave transition behavior to overlay components
// (dialog, sheet, popover, ...). Requires the `stimulus-use` package — pin it
// in your importmap or add it to your bundler when you add an overlay component.
export default class extends Controller {
  connect() {
    useTransition(this);
  }
}
